import type { ReactNode } from 'react';

import CaretDown from '@/assets/icons/caret_down_fill.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { Menu, MenuContent, MenuTrigger } from '@/components/molecules/Menu';

import styles from './OptoBreadCrumb.module.scss';

interface BreadcrumbMenuProps {
    label: ReactNode;
    isOpen: boolean;
    onOpenChange: (open: boolean) => void;
    disabled?: boolean;
    direction?: 'down' | 'up' | 'left' | 'right';
    menuClassName: string;
    children: ReactNode;
}

/** One level of the trail: the current entry, opening a list of its siblings. */
export default function BreadcrumbMenu(props: BreadcrumbMenuProps) {
    const { label, isOpen, onOpenChange, disabled, direction, menuClassName, children } = props;

    return (
        <Menu direction={direction} isOpen={isOpen} onOpenChange={onOpenChange}>
            <MenuTrigger variant="unstyled" className={styles.dropdownToggle} disabled={disabled}>
                {label}
                <SvgIcon icon={CaretDown} size="inherit" svgProps={{ 'aria-hidden': true }} />
            </MenuTrigger>
            <MenuContent className={menuClassName}>{children}</MenuContent>
        </Menu>
    );
}
